import { TOKEN_REFRESH_CHECK_INTERVAL_MS } from '../constants';
import type { SignalRManager } from './SignalRManager';

export class TokenRefresher {
	private intervalHandle: ReturnType<typeof setInterval> | null = null;
	private getAccessToken: (() => Promise<string>) | null = null;
	private manager: SignalRManager | null = null;
	private lastToken: string = '';

	public start(
		manager: SignalRManager,
		getAccessToken: () => Promise<string>
	): void {
		if (this.intervalHandle) {
			console.warn('[TokenRefresher] Already running');
			return;
		}

		this.manager = manager;
		this.getAccessToken = getAccessToken;

		this.checkAndRefreshToken();

		this.intervalHandle = setInterval(
			() => this.checkAndRefreshToken(),
			TOKEN_REFRESH_CHECK_INTERVAL_MS
		);
	}

	public stop(): void {
		if (this.intervalHandle) {
			clearInterval(this.intervalHandle);
			this.intervalHandle = null;
		}
		this.manager = null;
		this.getAccessToken = null;
		this.lastToken = '';
	}

	private async checkAndRefreshToken(): Promise<void> {
		if (!this.getAccessToken || !this.manager) return;

		try {
			const token = await this.getAccessToken();

			if (!token) {
				console.warn('[TokenRefresher] No token available');
				return;
			}

			if (token !== this.lastToken) {
				this.manager.updateToken(token);
				this.lastToken = token;
			}
		} catch (error) {
			console.error('[TokenRefresher] Failed to refresh token:', error);
		}
	}
}

